
class AiCreateMind {    
    constructor(id, data, status = 0) {
        this.id = id;
        this.data = data;
        this.status = status// 0:文件夹没有创建、没有移动；1:已经创建、已经移动; 2:处理出错
    }

    isDir() { //是不是文件夹
        return this.data.isDir
    }

    isCreateOrMove() {
        return this.status == 1
    }

    isProcessed() {
        return this.status == 1 || this.status == 2
    }
}
export default AiCreateMind